import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthHttp } from '../../../services/http/http.service';
import { Observable } from 'rxjs';

@Injectable()
export class GrupoService {
  private readonly _series: Observable<any>;

  constructor(private readonly http: HttpClient, private readonly authHttp: AuthHttp) {}

  set(grupo_id) {
    const key = GrupoService.name + '' + grupo_id;
    localStorage.setItem(key, JSON.stringify(grupo_id));
  }

  get(grupo_id) {
    const key = GrupoService.name + '' + grupo_id;
    return JSON.parse(localStorage.getItem(key));
  }
}
